module.exports = __webpack_public_path__ + "img/wertheim.c1b0ef44.jpg";